import axios from 'axios'
import request from '@/utils/request'
import { hashPasswordSync } from '@/utils/common'

// CSRF token
export function csrfToken() {
  return request.get('/clients/web/csrf/token')
}

// 下载链接远程配置地址
const DOWNLOAD_LINKS_URL = 'https://trangpt.ai/new-pc/download-links.json'

// 下载链接兜底（远程配置请求失败时使用）
export const DEFAULT_DOWNLOAD_URL = {
  win7: 'https://download.trangpt.world/new-pc/TranGPT-3.1.184-x64.exe',
  windows: 'https://download.trangpt.world/new-pc/TranGPT-3.1.184-x64.exe',
  macos: 'https://download.trangpt.world/new-pc/TranGPT-3.1.184-arm64.dmg',
  macos_intel: 'https://download.trangpt.world/new-pc/TranGPT-3.1.184-x64.dmg'
}

// 获取下载链接：优先请求远程配置，请求失败时回退到写死的默认值
export async function fetchDownloadUrl() {
  try {
    const { data } = await axios.get(DOWNLOAD_LINKS_URL, { timeout: 5000 })
    if (data && data.windows && data.macos) {
      return data
    }
    return DEFAULT_DOWNLOAD_URL
  } catch (error) {
    console.error('获取下载链接失败，使用默认下载链接:', error)
    return DEFAULT_DOWNLOAD_URL
  }
}

// 用户登录
export function login(params) {
  return hashPasswordSync(params.password).then(password => {
    return request.post('/clients/web/auth/login', { ...params, password })
  })
}

// 用户注册
export function register(params) {
  return hashPasswordSync(params.password).then(password => {
    return request.post('/clients/web/auth/register', { ...params, password })
  })
}

// 发送注册验证码
export function registerCode(email, captcha) {
  return request.post('/clients/web/auth/register/code', { email, captcha })
}

// 获取注册页下拉选项
export function getRegisterOptions() {
  return request.get('/clients/web/auth/register/options')
}

// 获取用户信息
export function getUserInfo() {
  return request.get('/clients/web/account/profile')
}

// 用户登出
export function logout() {
  return request.get('/clients/web/auth/logout')
}

// 更新密码
export async function updatePassword(currentPassword, newPassword) {
  const cp = await hashPasswordSync(currentPassword)
  return request.post('/clients/web/auth/password/change', { currentPassword: cp, newPassword })
}

// 发送重置密码链接
export function sendResetPasswordLink(params) {
  return request.post('/clients/web/auth/reset-password/link', params)
}

// 重置密码
export async function resetPassword(params) {
  const hashedPassword = await hashPasswordSync(params.newPassword)
  return request.post('/clients/web/auth/reset-password', { token: params.token, password: hashedPassword })
}

// 发送邮箱验证码
export function sendEmailCode(email) {
  return request.post('/clients/web/auth/send-change-email-code', { email })
}

// 更新邮箱
export function updateEmail(email, code) {
  return request.post('/clients/web/auth/change-email', { email, code })
}
